export const actionComponents = {
  RefreshEntityAction: () => import('./RefreshEntityAction.vue'),
  AutoAllocateAction: () => import('./AutoAllocateAction.vue'),
  SendApprovalAction: () => import('./SendApprovalAction.vue'),
  SendFormBuilderAction: () => import('./SendFormBuilderAction.vue'),
  SendDocTemplateAction: () => import('./SendDocTemplateAction.vue'),
  AddFolderAction: () => import('./AddFolderAction.vue'),
  DeleteFolderAction: () => import('./DeleteFolderAction.vue'),
  SelfUpdateAction: () => import('./SelfUpdateAction.vue'),
  SendEmailAction: () => import('./SendEmailAction.vue'),
  SendWhatsappAction: () => import('./SendWhatsappAction.vue'),
  SendWorkflowAction: () => import('./SendWorkflowAction.vue'),
  AutomateAction: () => import('./AutomateAction.vue'),
  CreateContactAction: () => import('./CreateContactAction.vue'),
  OtherUpdateAction: () => import('./OtherUpdateAction.vue'),
  OtherAddAction: () => import('./OtherAddAction.vue'),
  DefaultAction: () => import('./DefaultAction.vue'),
  AllocateUserForm: () => import('./AllocateUserForm.vue'),
};
